// ProductDetailsPopup.tsx
import React, { useState } from "react";
import { TaskItem } from "../pages/Task/Task";

interface ProductDetailsPopupProps {
  taskItem?: TaskItem | null;
  onClose: () => void;
}

const ProductDetailsPopup: React.FC<ProductDetailsPopupProps> = ({
  taskItem,
  onClose,
}) => {
  const [textCopied, setTextCopied] = useState(false);
  const [activePanel, setActivePanel] = useState<"input" | "output">("output");

  if (!taskItem || taskItem.response === null) return null;

  const response = taskItem.response;

  const copyToClipBoard = () => {
    if (!response) return;
    navigator.clipboard.writeText(response).then(() => {
      setTextCopied(true);
      setTimeout(() => setTextCopied(false), 1500);
    });
  };

  const inputFields = [
    { label: "Title", value: taskItem.productTitle },
    { label: "Description", value: taskItem.productDetails },
    { label: "Materials", value: taskItem.materials },
  ].filter((f) => f.value && f.value.trim() !== "");

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content popup-content--wide" onClick={(e) => e.stopPropagation()}>
        <div className="popup-header-row">
          <h3>Product Details</h3>
          <div className="popup-panel-tabs">
            <button
              className={`popup-panel-tab ${activePanel === "input" ? "active" : ""}`}
              onClick={() => setActivePanel("input")}
            >
              Input
            </button>
            <button
              className={`popup-panel-tab ${activePanel === "output" ? "active" : ""}`}
              onClick={() => setActivePanel("output")}
            >
              Output
            </button>
          </div>
        </div>

        <div className="popup-panels">
          {/* Input panel */}
          <div className={`popup-panel popup-panel--input ${activePanel === "input" ? "popup-panel--visible" : ""}` }>
            {inputFields.length > 0 ? (
              inputFields.map((field) => (
                <div className="popup-input-field" key={field.label}>
                  <span className="popup-input-label">{field.label}</span>
                  <p className="popup-input-value">{field.value}</p>
                </div>
              ))
            ) : (
              <p className="popup-empty">No input data available.</p>
            )}
          </div>

          {/* Output panel */}
          <div className={`popup-panel popup-panel--output ${activePanel === "output" ? "popup-panel--visible" : ""}`}>
            <div className="responseWrapper">
              {response
                ?.split("\n")
                .filter((line) => line.trim() !== "")
                .map((line, index) => (
                  <p key={index} style={{ marginBottom: "10px" }}>
                    {line}
                  </p>
                )) || <p>No response available.</p>}
            </div>
          </div>
        </div>

        <div className="buttonsWrapper">
          <button className="close-button" onClick={onClose}>
            Close
          </button>
          <button className="copy-button" onClick={copyToClipBoard}>
            <img src="/images/copyToClipBoard.svg" alt="copy" />
            {textCopied ? "Copied" : "Copy"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsPopup;
